import Experiment from '../containers/Experiment';

async function retrieveExperiment(id: number){
  const path = '/api/asebi/experiments/{id}'.replace('{id}', id.toString());
  const resp = await fetch(path);
  const json = await resp.json();

  const data = new Experiment();
  data.load(json);
  return data;
}

export default retrieveExperiment;
